import { remote, schema } from '../DataModel'

import { InitializedRecord, UninitializedRecord, RecordIdentity } from '@orbit/records'
import JSONAPISource, { JSONAPISerializers, JSONAPIResourceIdentitySerializer, JSONAPIResourceSerializer } from '@orbit/jsonapi'

export function newRecord<T extends InitializedRecord>(data : UninitializedRecord) : T {
  return remote.transformBuilder.$normalizeRecord(data) as T
}

export function buildRecord(type: string, id: string) : RecordIdentity {
  return { type: type, id: id }
}

// TODO: take `remote` as a parameter, rather than using the global remote
export function getRecordIdentity (type: string, remoteId: string) {
  const serializer = remote.requestProcessor.serializerFor(JSONAPISerializers.ResourceIdentity) as JSONAPIResourceIdentitySerializer
  return serializer.deserialize({ type: type, id: remoteId })
}

export function makeIsNew({ remote }: { remote: JSONAPISource }) {
  const getRemoteId = makeGetRemoteId({ remote })
  return (resource: InitializedRecord) => !getRemoteId(resource)
}

export function makeGetRemoteId({ remote }: { remote: JSONAPISource }) {
  return (resource: InitializedRecord) => {
    if(!resource) {
      return null
    }

    // TODO: Eliminate this clause once every model has been changed to have a remoteId key
    if (!schema.getModel(resource.type).keys) {
      return String(resource.id).match(/^[0-9]+$/) ? resource.id : undefined;
    }

    return (remote.requestProcessor.serializerFor(JSONAPISerializers.ResourceIdentity) as JSONAPIResourceSerializer).serialize(resource).id
  }
}
